import * as LeaderboardActions from '../actions/leaderboard.actions';
import { LeaderboardUserModel, CountryLeaderboard, CountryLeaderboardsData } from '../../models';

export type Action = LeaderboardActions.All;

export interface LeaderboardState {
    users: LeaderboardUserModel[];
    loading: boolean;
    error: string;
    countryLeaderboardsData: CountryLeaderboardsData;
    countryLeaderboard: CountryLeaderboard;
    countryLoading: boolean;
    countryError: string;
}

const defaultState: LeaderboardState = {
    users: [],
    loading: false,
    error: null,
    countryLeaderboardsData: null,
    countryLeaderboard: null,
    countryLoading: false,
    countryError: null,
};

export const leaderboardReducer = (state: LeaderboardState = defaultState, action: Action): LeaderboardState => {
    switch (action.type) {
        case LeaderboardActions.GET_LEADERBOARD: {
            return {
                ...state,
                users: [],
                loading: true,
                error: null
            };
        }

        case LeaderboardActions.GET_LEADERBOARD_SUCCESS: {
        return {
                ...state,
                users: action.users,
                loading: false,
                error: null
            };
        }

        case LeaderboardActions.GET_LEADERBOARD_FAILURE: {
        return {
                ...state,
                users: [],
                loading: false,
                error: action.error
            };
        }

        case LeaderboardActions.GET_COUNTRY_LEADERBOARDS: {
            return {
                ...state,
                countryLeaderboardsData: {},
                countryLeaderboard: {},
                countryLoading: true,
                countryError: null
            };
        }

        case LeaderboardActions.GET_COUNTRY_LEADERBOARDS_SUCCESS: {
        return {
                ...state,
                countryLeaderboardsData: action.leaderboards,
                countryLeaderboard: action.leaderboard,
                countryLoading: false,
                countryError: null
            };
        }

        case LeaderboardActions.GET_COUNTRY_LEADERBOARDS_FAILURE: {
        return {
                ...state,
                countryLeaderboardsData: {},
                countryLeaderboard: {},
                countryLoading: false,
                countryError: action.error
            };
        }

        case LeaderboardActions.UPDATE_COUNTRY_LEADERBOARD: {
            return {
              ...state,
              countryLeaderboard: action.leaderboard,
            };
        }

        default: {
            return state;
        }
    }
};



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/core/store/reducers/leaderboard.reducer.ts